var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notepad",
    transform: "translate(0.078 -0.031)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7423",
    "data-name": "Rectangle 7423",
    width: 20,
    height: 20,
    transform: "translate(-0.078 0.031)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 5,
    transform: "translate(7.922 10.031)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    x2: 5,
    transform: "translate(7.922 13.031)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65178",
    "data-name": "Path 65178",
    d: "M48.616,40h11.1a.616.616,0,0,1,.616.616V52.329a1.849,1.849,0,0,1-1.849,1.849h-8.63A1.849,1.849,0,0,1,48,52.329V40.616A.616.616,0,0,1,48.616,40Z",
    transform: "translate(-44.301 -36.613)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x2: 3,
    transform: "translate(8.922 7.031)",
    fill: "none",
    stroke: "#7a8797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.4a7c08c7d888e28d259e6c9612639c89.svg";
export { ForwardRef as ReactComponent };